<template>
  <div class="row full_height">
    <div class="col-lg-6">
      <div class="ml-4 mt-4">
        <div class="row">
          <div class="col-lg-8">
            <label>APELIDO DA MENSAGEM</label>
            <input class="form-control" v-model="feedback.name" />
            <span class="f12">APENAS IDENTIFICAÇÃO</span>
          </div>
          <div class="col-lg-4 col-xs-12">
            <label style="margin-top: 40px">
              <CheckBox
                :checked="feedback.use_video"
                class="mr-3 left"
                label="ADICIONAR VÍDEO"
              />
            </label>
          </div>
          <div class="col-lg-12 col-xs-12 pr-3">
            <label class="mt-3">STATUS</label>
            <br />

            <label>
              <input
                v-model="feedback.status"
                type="radio"
                name="status"
                value="1"
              />
              ATIVA
            </label>

            <label class="ml-3">
              <input
                v-model="feedback.status"
                type="radio"
                name="status"
                value="0"
              />
              INATIVA
            </label>
          </div>
        </div>
      </div>
      <transition name="fade" mode="out-in" appear>
        <div v-if="feedback.use_video">
          <div class="ml-4 mt-4">
            <label>APELIDO DO VÍDEO</label>
            <input type="text" class="form-control" v-model="video.name" />
            <span class="f12">
              DIGITE O APELIDO PARA
              <b>GRAVAR</b> OU FAZER
              <b>UPLOAD</b>
            </span>
          </div>
          <div class="ml-4 mt-4">
            <div class="row">
              <div class="col-lg-6">
                <button
                  :disabled="video.name == ''"
                  @click="recordVideo"
                  type="button"
                  class="btn full btn-primary"
                >
                  GRAVAR VÍDEO
                </button>
              </div>
              <div class="col-lg-6">
                <span
                  :disabled="video.name == ''"
                  class="btn full btn-success mb-1 btn-default btn-file"
                  style="border-radius: 0px"
                >
                  FAZER UPLOAD
                  <input
                    type="file"
                    :ref="`file`"
                    :disabled="video.name == ''"
                    v-on:change="sendMovieUpload()"
                    accept="video/*"
                    :id="`capture`"
                    capture="camcorder"
                  />
                </span>
              </div>
              <div class="col-lg-12">
                <button
                  @click="chooseVideo"
                  type="button"
                  class="btn mt-4 full btn-info"
                >
                  UTILIZAR VÍDEO DA GALERIA
                </button>
              </div>
              <transition name="fade">
                <SelectVideoGalleryItem v-if="gallery_select" />
              </transition>
            </div>
          </div>
        </div>
      </transition>
      <div class="ml-4 mt-4">
        <div>
          <label>TÍTULO DO E-MAIL</label>
          <input type="text" v-model="feedback.title" class="form-control" />
        </div>
        <div class="mt-3">
          <label>MENSAGEM</label>
          <ckeditor v-model="feedback.description" />
        </div>
        <div>
          <p class="f12">
            USE
            <b>{name}</b>PARA SUBSTITUIR PELO NOME DE CANDIDATO(A).
          </p>
        </div>
        <div class="mt-3" v-if="feedback.use_video">
          <label>TEXTO ADICIONAL PARA PÁGINA DO VÍDEO</label>
          <ckeditor v-model="feedback.additional_text" />
        </div>

        <div class="mt-3 mb-3"></div>
        <div class="row">
          <div class="col-lg-12 col-xs-12">
            <label>DESTINATÁRIO TESTE (OPCIONAL)</label>
            <input class="form-control" v-model="test_name" />
          </div>
          <div class="col-lg-12 col-xs-12">
            <label class="mt-3">E-MAIL TESTE (OPCIONAL)</label>
            <VueTagsInput
              v-model="test_email"
              :tags="test_emails"
              placeholder=""
              @tags-changed="(newTags) => (test_emails = newTags)"
            />
            <span class="f12"> PRESSIONE &#60;ENTER&#62; PARA ADICIONAR E-MAILS</span>
          </div>
        </div>
        <div class="row mt-3 mb-4">
          <div class="col-lg-6 col-xs-12">
            <button @click="makeTest" class="btn btn-info full">
              ENVIAR TESTE
            </button>
          </div>
          <div class="col-lg-6 col-xs-12">
            <button @click="saveEndClouse" class="btn btn-primary full">
              SALVAR
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="col-lg-6 col-xs-12 full_height"
      style="background-color: #414141"
    >
      <div v-if="!record && !load && !upload && !video.video" class="p-4">
        <div class="center container-icon-video" style="height: 337px">
          <font-awesome-icon
            icon="play"
            class="icon-pre-video"
            style="width: 35%; height: 35%; color: white"
          />
        </div>
      </div>

      <div v-show="record" class="p-4">
        <VideoJSRecordGallery
          :reference_id="feedback.id"
          :video="video"
          :gallery="gallery"
          :item="video"
          v-if="record"
          index="videoEditFeedback"
        />
      </div>
      <div class="p-4">
        <video
          v-show="video.video != false && record == false"
          width="100%"
          id="videoForm"
          controls
          controlslist="nodownload"
        >
          <source :src="video.video" />
        </video>

        <transition name="fade">
          <KProgress
            class="mt-4"
            v-if="percent > 0 && percent <= 99"
            :color="['#53358B', '#00baf7']"
            bg-color="#fff"
            :percent="percent"
          />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import KProgress from "k-progress";
import VideoJSRecordGallery from "components/VideoJSRecordGallery.vue";
import SelectVideoGalleryItem from "@/Recruiters/Galleries/SelectVideoGalleryItem.vue";
import CheckBox from "components/CheckBox.vue";
import { required, email } from "vuelidate/lib/validators";
import VueTagsInput from "@johmun/vue-tags-input";

export default {
  props: ["gallery", "selective_process"],
  components: {
    VideoJSRecordGallery,
    KProgress,
    SelectVideoGalleryItem,
    CheckBox,
    VueTagsInput,
  },
  mounted() {
    eventBus.$on("setFieldVideo", (fields) => {
      this.video = fields.gallery_item;
    });
    eventBus.$on("chooseVideo", (video) => {
      this.video.video_id = video.video_id;
      this.video.name = video.name;
      this.video.video = video.video;
      let video_current = document.getElementById("videoForm");
      video_current.load();
      this.gallery_select = false;
      // this.$modal.hideAll();
    });

    eventBus.$on("stopSave", (field) => {
      this.stopSave = field;
    });

    eventBus.$on("checkbox", (fields) => {
      this.feedback.use_video = fields.operator;
    });

    eventBus.$emit("setDraggable", false);

    axios
      .get(
        `/recruiters/feedback_selective_process/${this.selective_process.id}`
      )
      .then((response) => {
        if (response.data.feedback) {
          this.feedback = response.data.feedback;
          if (!this.feedback.use_video) eventBus.$emit("no_check");
          this.feedback.job_id = this.selective_process.job_id;
        }

        if (response.data.item) {
          this.video = response.data.item;
          let video_current = document.getElementById("videoForm");
          video_current.load();
        }
      });
  },
  data: () => ({
    load: false,
    record: false,
    upload: false,
    gallery_select: false,
    percent: 0,
    test_email: "",
    test_emails: [],
    test_name: "",
    stopSave: false,
    file: "",
    feedback: {
      id: 0,
      title: "",
      description: "",
      use_video: true,
      name: "",
      status: "1",
      job_id: 0,
      additional_text: "",
    },
    video: {
      id: 0,
      name: "",
      description: "",
      video: false,
      video_id: 0,
    },
  }),
  methods: {
    async saveEndClouse() {
      if (this.feedback.title == "" || this.feedback.description == "") {
        this.$toast.error("PREENCHA O TÍTULO E CORPO DO E-MAIL");
        return;
      }
      if (this.video.video_id === 0 && this.file === "")
        this.feedback.use_video = false;

      let response = await this.save();
      eventBus.$emit("clouseModalEditFeedback");
    },
    save() {
      return axios.post("/recruiters/feedback_selective_process", {
        feedbacks: this.feedback,
        selective_process_id: { id: this.selective_process.id },
        gallery_item: {
          id: this.video.id,
          video_id: this.video.video_id,
          name: this.video.name,
        },
      });
    },
    async makeTest() {
      if (this.feedback.title == "" || this.feedback.description == "") {
        this.$toast.error("PREENCHA O TÍTULO E CORPO DO E-MAIL");
        return;
      }

      if (this.test_name == "") {
        this.$toast.error("PREENCHA O NOME PARA REALIZAR O TESTE");
        return;
      }

      let emails = [];
      if (this.test_emails.length != 0) {
        for (let i = 0; i < this.test_emails.length; i++) {
          emails.push(this.test_emails[i].text);
        }
      }
      if (this.test_email != "") {
        emails.push(this.test_email);
      }
      if (emails.length == 0) {
        this.$toast.error(
          "PREENCHA OS EMAILS DE CADA PESSOA QUE RECEBERÁ O TESTE, SEPRANDO CADA E-MAIL APERTANDO 'ENTER' "
        );
        return;
      }
      let resp = await this.save();
      this.feedback = resp.data.feedback;
      axios
        .post("/recruiters/test_feedbacks", {
          feedback: {
            id: this.feedback.id,
            title: this.feedback.title,
            description: this.feedback.description,
          },
          video: {
            id: this.video.id,
            video: this.video.video,
          },
          user: {
            emails: emails,
            name: this.test_name,
          },
          selective_process: {
            id: this.selective_process.id,
          },
        })
        .then((response) => {
          if (response.data.status == true) {
            this.$toast.success(
              "TESTE ENVIADO COM SUCESSO, EM BREVE VOCÊ RECEBERÁ O E-MAIL"
            );
          }
        });
    },
    async recordVideo() {
      if (this.feedback.name == "") {
        this.$toast.error("PREENCHA O NOME DO FEEDBACK PARA CONTINUAR");
        return;
      }
      if (this.video.name == "") {
        this.$toast.error("PREENCHA O NOME DO FEEDBACK PARA CONTINUAR");
        return;
      }
      let response = await this.save();
      this.feedback = response.data.feedback;
      this.feedback.status = 1;
      this.closeOption();
      this.record = true;
    },
    closeOption() {
      this.record = false;
      this.upload = false;
      this.gallery_select = false;
    },
    chooseVideo() {
      this.closeOption();
      this.gallery_select = true;
    },
    async sendMovieUpload() {
      this.closeOption();
      this.upload = true;

      if (this.feedback.name == "") {
        this.$toast.error("Preencha o nome do feedback para continuar");
        return;
      }
      if (this.video.name == "") {
        this.$toast.error("Preencha o título do vídeo para continuar");
        return;
      }

      let response = await this.save();
      this.feedback = response.data.feedback;

      let formData = new FormData();
      this.file = this.$refs["file"].files[0];

      formData.append("video[file]", this.file);
      this.video.video = URL.createObjectURL(
        document.querySelector("#capture").files[0]
      );

      let video = document.getElementById("videoForm");
      video.load();

      video.onloadedmetadata = () => {
        video.muted = true;
        video.play();
        setTimeout(() => {
          video.muted = false;
          video.pause();

          let canvas = document.createElement("canvas");
          canvas.className = "hide";
          canvas.width = 480;
          canvas.height = 360;
          document.getElementsByTagName("body")[0].appendChild(canvas);
          canvas
            .getContext("2d")
            .drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
          canvas.toBlob((thumb) => {
            formData.append("videos[thumbnail]", thumb);
            formData.append("videos[file]", this.file);
            formData.append("videos[name]", this.video.name);
            formData.append("videos[description]", this.video.description);
            formData.append("videos[id]", this.video.video_id);

            formData.append(
              "galleries[gallery_category_id]",
              this.gallery.category_id
            );

            formData.append(
              "galleries[reference_id]",
              this.gallery.reference_id
            );
            formData.append("galleries[name]", this.gallery.name);
            formData.append(
              "galleries[item_category_id]",
              this.gallery.item_category_id
            );
            formData.append("galleries[id]", this.gallery.id);
            formData.append("gallery_item[id]", this.video.id);
            formData.append("gallery_item[reference_id]", this.feedback.id);

            axios
              .post("/recruiters/galleries/videos?no_replace=true", formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
                onUploadProgress: (progressEvent) => {
                  const totalLength = progressEvent.lengthComputable
                    ? progressEvent.total
                    : progressEvent.target.getResponseHeader(
                        "content-length"
                      ) ||
                      progressEvent.target.getResponseHeader(
                        "x-decompressed-content-length"
                      );

                  if (totalLength !== null) {
                    this.percent = parseInt(
                      (progressEvent.loaded * 100) / totalLength
                    );
                  }
                },
              })
              .then((resp) => {
                this.stopSave = false;
                this.video.id = resp.data.gallery_item.id;
                this.video.video_id = resp.data.gallery_item.video_id;
              })
              .catch(function (error) {
                console.log(error);
              });
          });
        }, 2000);
      };
    },
  },
  validations: {
    teste: {
      email: { required, email },
      name: { required },
    },
    feedback: {
      title: { required },
      description: { required },
    },
  },
};
</script>
